import Vue                      from "vue";
import { mapGetters }           from "vuex";
import { sizeHelper,
    stringHelper }              from "@/components/mixins";
import { IPartQuoteRequestDto } from "@/types";
import { PartSearchService }    from "@/services/";
import DnFunctionButton         from "@/components/Elements/DnFunctionButton.vue";
import LoadingSpinner           from "@/components/Elements/LoadingSpinner.vue";

export default Vue.extend({
    name: "PartRequestQuote",
    components: {
        DnFunctionButton,
        LoadingSpinner
    },
    computed: {
        ...mapGetters([
            "user",
            "getContentItem"
        ]),
    },
    mixins: [sizeHelper, stringHelper],
    props: {
        oemPartCode: String,
        oem: String,
        model: String
    },
    created() {
    },
    data: () => ({
        isEnteringMsg: true,
        isSubmittingQuote: false,
        submittedQuote: false,
        submitSuccess: false,
        toEmail: { type: String, default: "" },
        partQuoteRequest: {} as IPartQuoteRequestDto
    }),
    methods: {
        SubmitQuote() {
            this.isEnteringMsg = false
            this.isSubmittingQuote = true;

            this.partQuoteRequest.UserId = this.user.UserId;
            this.partQuoteRequest.Name = this.user.FullName;
            this.partQuoteRequest.Email = this.user.Email;
            this.partQuoteRequest.DealerCode = this.user.DealerCode;
            this.partQuoteRequest.OemPartCode = this.oemPartCode;
            this.partQuoteRequest.TruckOem = this.oem;
            this.partQuoteRequest.TruckModel = this.model;

            let self = this;
            PartSearchService.PartQuoteRequest(this.partQuoteRequest).then(response => {
                self.submitSuccess = response.data.Item1;
                self.toEmail = response.data.Item2;

                self.isSubmittingQuote = false;
                self.submittedQuote = true;

                const fiveSeconds = 5 * 1000;
                setTimeout(function () {
                    self.$emit("quoteSubmitted");
                }, fiveSeconds)

            })
        }
    }
});